/*
 * Jira Ticket:
 * Created Date: Tue, 24th Mar 2020, 17:42:46 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import edit from './edit';
import create from './create';

export default {
  edit,
  create,
};
